import { render, staticRenderFns } from "./AiIosBookTaskManage.vue?vue&type=template&id=f665283a&scoped=true"
import script from "./AiIosBookTaskManage.vue?vue&type=script&lang=js"
export * from "./AiIosBookTaskManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f665283a",
  null
  
)

export default component.exports